// @flow
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Redirect, Route, NavLink, Switch } from 'react-router-dom';

import { ingestForms } from 'view/App/pageData';
import type { Catalog } from 'state/types';

type Props = {
  catalog: Catalog,
};

// Simple parent container for ingest forms (e.g. Cataloging Options,
// Managed Uploads, etc.)
export default class CatalogIngestPage extends Component<Props> {
  render() {
    const { catalog } = this.props;
    return (
      <div className="page" data-test-name="catalog-ingest-page">
        <header className="page-header-tabs-container-secondary">
          <div className="tabs is-centered is-full-width">
            <ul>
              {ingestForms.map(form => (
                <li
                  key={form.route}
                  data-test-name={
                    'nav-link-' + (form.label.defaultMessage || 'unknown')
                  }
                >
                  <NavLink
                    activeClassName="nav-item-horizontal-secondary-selected"
                    className="nav-item-horizontal-secondary"
                    to={`/catalogs/${catalog.catalogId}/ingest/${form.route}`}
                  >
                    <FormattedMessage {...form.label} />
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </header>

        <Switch>
          {ingestForms.map(form => (
            <Route
              key={form.route}
              path={`/catalogs/${catalog.catalogId}/ingest/${form.route}`}
              render={props => <form.component catalog={catalog} />}
            />
          ))}
          <Redirect
            exact
            from="/catalogs/:catalogId/ingest"
            to={`ingest/${ingestForms[0].route}`}
          />
        </Switch>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/Pages/CatalogsPage/CatalogIngestPage.js